// extracted by mini-css-extract-plugin
export default {"logo":"Logo_logo__t29bR","logo-image":"Logo_logo-image__vT7aN","logo-name":"Logo_logo-name__sw6X4"};